<shared-list-for-rewards [limit]="limit" [placeholders]="2" [loading]="loading$ | async"
    class="loyalty-for-member-rewards" [rewards]="(rewards$ | async)">
</shared-list-for-rewards>

<ng-container *ngIf="(showNoRewardsInfo$ | async) === true">
    <shared-short-message [title]="noRewardsTitle" [button]="noRewardsButton" (onClick)="handleOrderNowClick($event)">
        {{noRewardsText}}</shared-short-message>
</ng-container>